<template>
  <el-button @click="deleteProjectConfirm">删除项目</el-button>
</template>
<script>
import { editProject } from '@/services/proj/bid-project-service';
export default {
  name: 'ProjBidBtnDeleteList',
  props: {
    project: {
      required: true,
      tyle: Object
    }
  },
  data() {
    return {
      user: this.$store.state.user.userInfo
    };
  },
  methods: {
    deleteProjectConfirm: function() {
      this.$ebConfirm('确认要删除项目吗?')
        .then(() => {
          this.deleteProject();
        })
        .catch(() => {});
    },
    async deleteProject() {
      try {
        let params = {
          projectId: this.project.projectId,
          updateId: this.user.userid,
          isRemove: 1,
          removeId: this.user.userid,
          removeTime: this.$options.filters['dateTimeStandardFormat'](new Date()),
          updateTime: this.$options.filters['dateTimeStandardFormat'](new Date())
        };
        let { data } = await editProject(params);
        if (data.returnCode === '01') {
          this.$message.success('删除成功');
          this.$emit('onDeleteBidProject');
        } else {
          this.$message.error('删除失败请稍后重试');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>
<style scoped lang="less">

</style>
